<template>
    <div>
        <div class="container-list" v-if="view == 'list'">
            <RoutingList 
                :my_drivers="my_drivers"
                :my_courses="my_courses"
                :my_settings="my_settings"
                @update="updateData"
                @view="changeView"
            />
        </div>
        <div class="container-form" v-if="view == 'form'">
            <RoutingForm 
                :my_customers="my_customers"
                :my_dcs="my_dcs"
                :my_documents="my_documents"
                :my_drivers="my_drivers"
                :my_settings="my_settings"
                :my_vehicles="my_vehicles"
                @update="updateData"
                @view="changeView"
            />
        </div>
        <div class="container-map" v-if="view == 'map'">
            <RoutingMap
                :data="data"
                :my_drivers="my_drivers"
                :my_courses="my_courses"
                :my_settings="my_settings"
                @update="updateData"
                @view="changeView" 
            />
        </div>
    </div>
</template>

<script>
import Api from "@/lib/Api";

import RoutingList from './Routing/RoutingList';
import RoutingForm from './Routing/RoutingForm';
import RoutingMap from './Routing/RoutingMap';

export default {
    name: "Routing",

    components: {
        RoutingList,
        RoutingForm,
        RoutingMap,
    },

    data: function() {
        return {
            loading: false,
            view: 'list',
            data: [],
            my_dcs: [],
            my_customers: [],
            my_courses: [],
            my_documents: [],
            my_drivers: [],
            my_settings: {},
            my_vehicles: [],
        }
    },

    beforeCreate: function() {
		if (!this.$api.user.is_admin) {
			let permissions = this.$api.user.permissions.split(",");
			if (!permissions.includes("DeliveryRouting")) {
				this.$router.push({ name: 'Home' });
			}
		}
	},

    mounted: async function() {
        this.loading = true;
        await this.loadSettings();
        await this.loadDCs();
        await this.loadVehicles();
        await this.loadDrivers();
        await this.loadCustomerDocument();
        await this.loadCompanyDocument();
        await this.loadCourses();
        this.loading = false;
    },

    methods: {
        // Carrega a lista de clientes
        loadCustomerDocument: async function() {
			let result = null;
			try {
				result = await Api.post("customer/list-my-customers");
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações de clientes.");
				return;
			}

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.my_customers = result.data;
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter todas as informações de clientes.");
				return;
			}
		},

        // Carrega a lista de filiais
        loadCompanyDocument: async function() {
            let result = null;
            try {
                result = await Api.post("delivery/list-my-documents");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter todas as informações de filiais.");
                return;
            }

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.my_documents = result.data;
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter todas as informações de filiais.");
                return;
			}
		},

        /**
         * Obtém a lista de Centros de Distribuição
         */
         loadDCs: async function() {
            let result = null;

            try {
                result = await Api.post("distribution-center/list-my-dcs");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter a lista de centros de distribuição.");
                return;
            }

			if (result) {
                if (result.error) {
                    if (result.data == "unauthorized") {
                        this.$notification.error("Desculpe, sua sessão expirou.");
                        setTimeout(() => { 
                            Api.logout();
                            return;
                        }, 2000);
                    } else {
                        this.$notification.error(result.data);
                        return;
                    }
                } else {
                    this.my_dcs = result.data;
                    return;
                }
            } else {
                this.$notification.error("Não foi possível obter a lista de centros de distribuição.");
                return;
            }
        },

        /**
         * Requisita lista de motoristas vinculados
         **/ 
         loadDrivers: async function() {
            let result = null;

            try {
                result = await Api.post("driver/list-my-drivers");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter a lista de motoristas.");
                return;
            }
			
            if(result) {
                if(result.error) {
                    if (result.data == "unauthorized") {
                        this.$notification.error("Desculpe, sua sessão expirou.");
                        setTimeout(() => { 
                            Api.logout();
                            return;
                        }, 2000);
                    } else {
                        this.$notification.error(result.data);
                        return;
                    }
                } else {
                    this.my_drivers = result.data;
                    return;
                }
            } else {
                this.$notification.error("Não foi possível obter a lista de motoristas.");
                return;
            }
		},
        
        /**
         * Obtém as configurações padrão
         */
         loadSettings: async function() {
            let result = null;
            
            try {
                result = await Api.post("config/load-settings");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter todas as informações de configuração.");
                return;
            }

            if (result) {
                if (result.error) {
                    if (result.data == "unauthorized") {
                        this.$notification.error("Desculpe, sua sessão expirou.");
                        setTimeout(() => { 
                            Api.logout();
                            return;
                        }, 2000);
                    } else {
                        this.$notification.error(result.data);
                        return;
                    }
                } else {
                    this.my_settings = Object.assign({}, result.data);
                    return;
                }
            } else {
                this.$notification.error("Não foi possível obter todas as informações de configuração.");
                return;
            }
        },
        
        /**
         * Carrega a lista de filiais
         */
        loadVehicles: async function() {
            let result = null;

            try {
                result = await Api.post("vehicle/list-my-vehicles");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter a lista de veículos.");
                return;
            }

			if (result) {
                if (result.error) {
                    if (result.data == "unauthorized") {
                        this.$notification.error("Desculpe, sua sessão expirou.");
                        setTimeout(() => { 
                            Api.logout();
                            return;
                        }, 2000);
                    } else {
                        this.$notification.error(result.data);
                        return;
                    }
                } else {
                    this.my_vehicles = result.data;
                    return;
                }
            } else {
                this.$notification.error("Não foi possível obter a lista de veículos.");
                return;
            }
		},

        /**
         * Requisita lista de percursos
         **/ 
         loadCourses: async function() {
            let result = null;

            try {
                result = await Api.post("delivery-course/list-my-courses");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter a lista de percursos.");
                return;
            }
			
            if(result) {
                if(result.error) {
                    if (result.data == "unauthorized") {
                        this.$notification.error("Desculpe, sua sessão expirou.");
                        setTimeout(() => { 
                            Api.logout();
                            return;
                        }, 2000);
                    } else {
                        this.$notification.error(result.data);
                        return;
                    }
                } else {
                    this.my_courses = result.data;
                    return;
                }
            } else {
                this.$notification.error("Não foi possível obter a lista de percursos.");
                return;
            }
		},
        
        /**
         * Muda a página atual
         * @param {string} value string da view que deve ser exibida
         */
        changeView: function(value) {
            this.view = value;
        },
        
        /**
         * Atualiza o objeto de de dados
         * @param {object} data objeto com as informações que deverão ser atualizadas
         */
        updateData: function(data) {
            this.data = data;
        },
    }
}
</script>

<style scoped>

</style>